import type { FC } from 'react'

import { AccountingReports } from './AccountingReports'
import { Consumption } from './Consumption'
import { NewNumberOrders } from './NewNumberOrders'
import { OffBoarding } from './OffBoarding'
import { SalaryDeductionDevice } from './SalaryDeductionDevice'
import { SalaryDeductionUsage } from './SalaryDeductionUsage'
import { TaxAdvantage } from './TaxAdvantage'

import type { ReportFilters } from '../../resources'

export const ReportList: FC<{
  filters: ReportFilters
}> = ({ filters }) => {
  switch (filters.selectedReportType) {
    case 'accounting':
      return <AccountingReports filters={filters} />
    case 'off-boarding':
      return <OffBoarding filters={filters} />
    case 'consumption':
      return <Consumption filters={filters} />
    case 'ssd-order':
      return <SalaryDeductionDevice filters={filters} />
    case 'salary-deduction-usage':
      return <SalaryDeductionUsage filters={filters} />
    case 'tax-advantage':
      return <TaxAdvantage filters={filters} />
    case 'new-number-orders':
      return <NewNumberOrders filters={filters} />
    default:
      return null
  }
}
